import { formValidation } from '../global/_formValidation';
import { getHtmlContent as _getHtmlContent } from './_getHTMLContent';
import { ajaxEmailSignup as _ajaxEmailSignup } from './_ajaxEmailSignup';
import { ajaxTextSignup as _ajaxTextSignup } from './_ajaxTextSignup';
import { iOSModalFix } from '../deviceSpecific/_iOS';
import { citibankSpeedbump as _citibankSpeedbump } from './_citibankOffer';
import { setCookieOrWebStorage } from '../global/_cookies';
import { returnToOriginalPos } from '../registry/_manageRegistry';
import { infoBoxModals as _infoBoxModals } from './_infoBoxModals';
import $ from 'jquery';

export const dillardsModal = () => {
	var allModals = {
		getHtmlContent: _getHtmlContent,
		ajaxEmailSignup: _ajaxEmailSignup,
		ajaxTextSignup: _ajaxTextSignup,
		citibankSpeedbump: _citibankSpeedbump,
		infoBoxModals: _infoBoxModals,
	};

	// A public method that can fire a dynamic modal.
	dillardsModal.triggerModal = function (partial, title, modalClass) {
		if ($('.mobilePage').length > 0) setCookieOrWebStorage('sessionStorage', 'modalPos', $(document).scrollTop());
		var modalData = {};
		modalData.title = title;
		modalData.link = '.' + modalClass;
		modalData.partial = partial;
		$.get('/assets/empty-modal-partial.html', function (partial) {
			$('body').append(partial);
			fireModal(modalData);
		});
	};

	var fireModal = function (trigger) {
		$('html').addClass('html-modal-open');
		var modalContainer = $('#dynamicModalContainer'),
			modalBody = modalContainer.find('.modal-body').first(),
			modalLinkClicked = $(trigger).data('target') || trigger.link,
			modalTitle = $(trigger).data('modal-title') || trigger.title,
			partialToLoad = $(trigger).data('modal-body') || trigger.partial,
			modalFunctionName = partialToLoad,
			modalParams,
			paramJSON;
		//This is the function that calls for the return of HTML.
		function loadHTML(callBack) {
			allModals[modalFunctionName](paramJSON, callBack);
		}
		// If this method sees that the 'modal-body' data attribute containes a '(' in the string it will assume that the the function has parameters.
		// The parameters pased MUST be in JSON format. Ex. modalFunction({"aString":"Some String","aNumber":12345})
		// Must use double-ticks in the parameters!
		// If there are no parameters needed to be passed the parentheses in the mark-up are optional.
		// NOTE THAT, CURRENTLY, ALL PARAMETERS COME THROUGH AS A SINGLE STRING!
		// The parameters will need to be parsed and/or converted to integers in your method. Use pipes, commas, etc. to seperate.
		if (partialToLoad && partialToLoad.indexOf('(') > -1) {
			modalFunctionName = partialToLoad.split('(')[0];
			modalParams = partialToLoad.split(modalFunctionName)[1].split('(')[1].split(')')[0];
			paramJSON = JSON.parse(modalParams);
		}
		//Sets modal title
		$('#dynamicModalContainer #ModalLabel').text(modalTitle.split('#double;').join('"'));
		// Below checks if what was passed into the 'modal-body' data attribute is a function or not.
		// If it is NOT a function it will assume it is to load a static HTML file into the body of the modal, and will do so.
		// If it IS a function it will assume that the function will be returning a string of HTML and it will load that return data into the body of the modal.
		if (typeof allModals[modalFunctionName] == 'function') {
			//loadHTML will load the HTML to the page THEN run the scripts that are returned.
			loadHTML(function (returnHTML, scriptsCB) {
				modalBody.html(returnHTML);
				var modalSelector = modalContainer.addClass(modalLinkClicked.replace('.', ''));
				if (modalSelector.hasClass('next-day') || modalSelector.hasClass('modal-address-verification')) {
					modalSelector.modal({
						keyboard: false,
						backdrop: 'static',
						show: true,
					});
				} else {
					modalSelector.modal('show');
					modalSelector.addClass('in');
				}
				//check if callback (modal scripts to execute) exists and is a function
				if (scriptsCB && typeof scriptsCB == 'function') scriptsCB();

				formValidation(); // Calling formValidation() to re-check for forms in modal and set-up an validation
				iOSModalFix();
			});
		} else {
			modalBody.load(partialToLoad, function () {
				//There is no need to run scripts via a call back because the scripts should run when the static HTML is added to the page
				var modalSelector = modalContainer.addClass(modalLinkClicked.replace('.', ''));
				if (modalSelector.hasClass('next-day') || modalSelector.hasClass('modal-address-verification')) {
					modalSelector.modal({
						keyboard: false,
						backdrop: 'static',
						show: true,
					});
				} else {
					modalSelector.modal('show');					
					modalSelector.addClass('in');
				}

				formValidation(); // Calling formValidation() to re-check for forms in modal and set-up an validation
			});
		}
		modalContainer.on('hidden.bs.modal', function () {
			$('#dynamicModalContainer, .modal-backdrop, .modalDynamicRemove').remove();
			$('html').removeClass('html-modal-open');
			if (!$('.desktopPage').length > 0) returnToOriginalPos('modalPos');
		});
	};
	$('body').off('click.bindModalClicks');
	$('body').on('click.bindModalClicks', '[data-toggle="modal"]', function (e) {
		if ($(this).data('modal-body') && $(this).data('modal-body').indexOf('QuickView') > -1) {
			return true;
		}
		var once = true;
		if ($('.mobilePage').length > 0) setCookieOrWebStorage('sessionStorage', 'modalPos', $(document).scrollTop());
		// A check for form validation before launching modal
		if ($(this).data('modal-body') && $(this).data('modal-title')) {
			var hasNoValidation = this.hasAttribute('data-novalidation'), // this allows buttons and links to live in the form and NOT trigger validation. Add 'data-novalidation' to element
				// When the "shopping-actions" were moved outside of the form in QuickView
				// they needed to be found by starting from "modal-content" instead of in the form. --Joshua Spaeth
				theForm = $('.modal-content:visible').length > 0 ? $(this).parents('.modal-content').find('.modal-body').find('form') : $(this).parents('form'),
				allFormInputs = theForm.find('*[data-validate]'),
				formValid = hasNoValidation ? true : theForm.data('validForm');
			//Multiple validation checks before launching the modal
			$.each(allFormInputs, function () {
				if (formValid && !hasNoValidation) formValid = $(this).data('fieldValid') !== undefined ? $(this).data('fieldValid') : false;
			});
			if (formValid || formValid === undefined) {
				var triggerClicked = this;
				// Double checks for an exsiting dynamicModal and removes it or hides it.
				if ($(triggerClicked).parents('#dynamicModalContainer').length === 0) {
					$('.modal-backdrop, .modalDynamicRemove').remove();
					$('#dynamicModalContainer').remove();
				} else {
					$('#dynamicModalContainer').removeAttr('id').attr('class', 'modalDynamicRemove').hide();
					$('.modal-backdrop').remove();
				}
				if (once) {
					var modalToLoad = $(triggerClicked).data('modal-body') || triggerClicked.partial;
					if (modalToLoad.indexOf('QuickView') > -1) {
						var modalBody = $('.dynamicModalContainer').find('.modal-body').first(),
							modalTitle = $(triggerClicked).data('modal-title') || triggerClicked.title,
							modalFunctionName = modalToLoad,
							modalParams,
							paramJSON;
						modalTitle = modalTitle.split('#double;').join('"');
						if (modalToLoad && modalToLoad.indexOf('(') > -1) {
							modalFunctionName = modalToLoad.split('(')[0];
							modalParams = modalToLoad.split(modalFunctionName)[1].split('(')[1].split(')')[0];
							paramJSON = JSON.parse(modalParams);
						}
						var position = $(triggerClicked).offset().top;
						if ($('html').hasClass('no-localstorage')) {
							Cookies.set('qvClickPos', position, {
								path: '/',
								domain: false,
							});
						} else localStorage.setItem('qvClickPos', position);
						// buildQV(paramJSON, modalTitle);
					} else {
						$.get('/assets/empty-modal-partial.html', function (partial) {
							$('body').append(partial);
							fireModal(triggerClicked);
						}).done(function () {
							once = false;
						});
					}
				}
			}
			return false;
		}
	});
};
